"use client";
import { createContext } from "../../utils/create-context.js";
//#region src/components/progress/use-progress-context.ts
var [ProgressProvider, useProgressContext] = createContext({
	name: "ProgressContext",
	hookName: "useProgressContext",
	providerName: "<ProgressProvider />"
});
//#endregion
export { ProgressProvider, useProgressContext };
